import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Redirect } from "react-router";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import { addManager, editManager, ManagerDetail } from "./services";

class ManagersDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      managerId:
        window.location.pathname.split("/")[4] === "add"
          ? null
          : window.location.pathname.split("/")[4],
      shopUid: window.location.pathname.split("/")[2],
      phone: "",
      role: "",
      isActive: true,
      redirect: false,
    };
  }
  componentDidMount() {
    if (this.state.managerId) {
      this.getAdminDetail();
    }
  }
  getAdminDetail() {
    ManagerDetail(this.state.shopUid, this.state.managerId).then((items) => {
      items &&
        this.setState({
          role: items.role,
          isActive: items.active,
          phone: items.user.phone,
        });
    });
  }
  editAdminProperties() {
    let params = {
      role: this.state.role,
      active: this.state.isActive,
    };
    editManager(this.state.shopUid, this.state.managerId, params).then(
      (items) => {
        items &&
          this.setState({
            redirect: true,
          });
      }
    );
  }
  addAdminProperties() {
    let params = {
      user: this.state.phone,
      role: this.state.role,
      active: this.state.isActive,
    };
    addManager(this.state.shopUid, params).then((items) => {
      if (
        items.response &&
        items.response.status &&
        items.response.status === 400
      ) {
        console.log(items.response);
        this.setState({
          errMsg: items.response.data.errors.user[0].message,
        });
      } else {
        this.setState({
          redirect: true,
        });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid">
        {this.state.redirect && (
          <Redirect to={`/dashboard/${this.state.shopUid}/managers`} />
        )}
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "99999" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">
              {this.state.managerId
                ? "ویرایش مدیر فروشگاه"
                : "مدیر جدید فروشگاه"}
            </h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() =>
                this.state.managerId
                  ? this.editAdminProperties()
                  : this.addAdminProperties()
              }
              className="btn fs-6 p-0 fw-bold mb-0 color-main disabled-color"
              disabled={
                !this.state.phone ||
                this.state.phone.length !== 11 ||
                !this.state.role
              }
            >
              {this.state.managerId ? "ذخیره" : "ثبت"}
            </button>
          </div>
        </header>
        <body style={{ marginTop: "80px" }}>
          <div className="row mx-0">
            <div className="col-12 px-0 position-relative">
              <input
                placeholder="تلفن همراه مدیر"
                type="tel"
                dir={this.state.phone ? "ltr" : "rtl"}
                onFocus={(e) => {
                  e.target.dir = "ltr";
                  e.target.placeholder = "";
                }}
                onBlur={(e) => {
                  e.target.placeholder = "تلفن همراه مدیر";
                  e.target.dir = "rtl";
                }}
                disabled={this.state.managerId}
                maxLength="11"
                value={this.state.phone}
                onChange={(e) => this.setState({ phone: e.target.value })}
                className="rounded14 w-100 form-control p-3"
              />
              {this.state.phone && <SimpleLabel text="تلفن همراه مدیر" />}
              {this.state.errMsg && (
                <p className="text-danger mt-2 small fw-bold">
                  {this.state.errMsg}
                </p>
              )}
            </div>
            <div className="col-12 px-0 my-4 position-relative">
              <input
                placeholder="نقش مدیر"
                dir="rtl"
                value={this.state.role}
                onChange={(e) => this.setState({ role: e.target.value })}
                className="rounded14 w-100 form-control p-3"
              />
              {this.state.role && <SimpleLabel text="نقش مدیر" />}
            </div>
            <div className="col-auto">
              <span className="fw-bold ms-3">
                {this.state.isActive ? "فعال" : "غیر فعال"}
              </span>
            </div>
            <div className="col text-start">
              <input
                className="form-check-input"
                value={this.state.isActive}
                checked={this.state.isActive}
                onChange={() =>
                  this.setState({
                    isActive: !this.state.isActive,
                  })
                }
                type="checkbox"
              />
            </div>
          </div>
        </body>
      </div>
    );
  }
}

export default ManagersDetail;
